import { useState, useEffect, createContext } from "react";
import { AxiosResponse } from "axios";
import {
  typeFormDto,
  typeCountryDto,
  iTypeFormCategories,
  formContextTypes,
  countryDataTypes,
  typeApiResponse,
  formCategoryDataTypes,
} from "../../utils/typeDefs";
import { apiUrls } from "../../utils/apiUrls";
import { convertDate, getData } from "../../utils/reusables";

const FormContext = createContext<formContextTypes | null>(null);

type formProps = {
  children: JSX.Element;
};

const FormContextProvider = ({ children }: formProps) => {
  const [formPageData, setFormPageData] = useState<typeFormDto[] | null>(null);
  const [formCountryData, setFormCountryData] = useState<typeCountryDto[] | []>(
    []
  );
  const [sortedCountryData, setSortedCountryData] = useState<
    typeCountryDto[] | []
  >([]);
  const [currentCountryId, setCurrentCountryId] = useState<number | null>(null);
  const [currentId, setCurrentId] = useState<number | null>(null);
  const [formCategoryData, setFormCategoryData] = useState<
    iTypeFormCategories[] | []
  >([]);
  const [currentRowData, setCurrentRowData] = useState<typeFormDto | null>(
    null
  );

  useEffect(() => {
    getData(apiUrls.country.base).then(
      (result: AxiosResponse<countryDataTypes & typeApiResponse>) =>
        setFormCountryData(result.data.data)
    );
    getData(apiUrls.form.getCategories).then(
      (result: AxiosResponse<formCategoryDataTypes & typeApiResponse>) =>
        setFormCategoryData(result.data.data)
    );
  }, []);

  useEffect(() => {
    if (formCountryData.length > 0) {
      const sortedCountryData = formCountryData.sort(
        (a: typeCountryDto, b: typeCountryDto) => (a.name > b.name ? 1 : -1)
      );

      setSortedCountryData(sortedCountryData);
    }
  }, [formCountryData]);

  useEffect(() => {
    if (currentCountryId !== null) {
      getData(apiUrls.form.getForms(currentCountryId)).then(
        (result: AxiosResponse<typeFormDto[] & typeApiResponse>) => {
          setFormPageData(result.data);
        }
      );
    } else setFormPageData([]);
  }, [currentCountryId]);

  useEffect(() => {
    if (formPageData && formPageData.length > 0) {
      formPageData.forEach((item) => {
        item.entryIntoForce = convertDate(item.entryIntoForce);
        item.lastReview = convertDate(item.lastReview);
      });

      setFormPageData(formPageData);
    }
  }, [formPageData]);

  useEffect(() => {
    if (currentId) {
      getData(apiUrls.form.getFormById(currentId)).then((result) => {
        if (result.status === 200) {
          setCurrentRowData(result.data);
          return true;
        } else return false;
      });
    }
  }, [currentId]);

  return (
    <FormContext.Provider
      value={{
        formPageData,
        formCategoryData,
        setFormPageData,
        sortedCountryData,
        setFormCountryData,
        currentCountryId,
        setCurrentCountryId,
        setCurrentId,
        currentRowData,
      }}
    >
      {children}
    </FormContext.Provider>
  );
};

export { FormContext, FormContextProvider };
